import { useState, useEffect } from 'react';
import { getAdminStories } from '../../api/admin';
import s from './AdminPages.module.css';

export default function AdminStories() {
  const [data, setData] = useState({ stories: [], pagination: {} });
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);

  useEffect(() => {
    getAdminStories({ page })
      .then(setData)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [page]);

  const { pagination } = data;

  return (
    <div>
      <h1 className={s.title}>Stories</h1>

      <div className={s.tableWrap}>
        <table className={s.table}>
          <thead>
            <tr>
              <th className={s.th}>Title</th>
              <th className={s.th}>Child</th>
              <th className={s.th}>Theme</th>
              <th className={s.th}>Curriculum</th>
              <th className={s.th}>Status</th>
              <th className={s.th}>New Chars</th>
              <th className={s.th}>Created</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={7} className={s.td}>Loading...</td></tr>
            ) : data.stories.length === 0 ? (
              <tr><td colSpan={7} className={s.td}>No stories yet</td></tr>
            ) : (
              data.stories.map((story) => (
                <tr key={story.id}>
                  <td className={s.td}>
                    <span className={s.storyTitle}>{story.title || 'Untitled'}</span>
                  </td>
                  <td className={s.td}>{story.child_name}</td>
                  <td className={s.td}>
                    <span className={s.themeBadge}>{story.theme || '-'}</span>
                  </td>
                  <td className={s.td}>{story.curriculum_name || '-'}</td>
                  <td className={s.td}>
                    <StatusBadge status={story.status} />
                  </td>
                  <td className={s.td}>{story.new_characters_introduced || 0}</td>
                  <td className={s.td}>{formatDate(story.created_at)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {pagination.pages > 1 && (
        <div className={s.paginationRow}>
          <button
            disabled={page <= 1}
            onClick={() => setPage(page - 1)}
            className={s.pageBtn}
          >
            Prev
          </button>
          <span className={s.pageInfo}>
            Page {pagination.page} of {pagination.pages}
          </span>
          <button
            disabled={page >= pagination.pages}
            onClick={() => setPage(page + 1)}
            className={s.pageBtn}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}

function StatusBadge({ status }) {
  const variantMap = {
    unread: s.statusBadgeUnread,
    read: s.statusBadgeRead,
    reviewed: s.statusBadgeReviewed,
  };

  const variantClass = variantMap[status] || s.statusBadgeDefault;

  return (
    <span className={`${s.badge} ${variantClass}`}>
      {status || 'unknown'}
    </span>
  );
}

function formatDate(iso) {
  if (!iso) return '-';
  return new Date(iso).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}
